import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import { Typography } from '@mui/material';
import Wrapper from '../Wrapper';
import { Props, defaultAccept, defaultHeading, defaultId } from '../utils';
import styles from './styles';
import { getAcceptedFileTypes, getFileTypesMsg } from './utils';

export default function Upload({
  id = defaultId,
  heading = defaultHeading,
  helper = '',
  onChange,
  multiple = false,
  accept = defaultAccept,
  invalid = false,
}: Props) {
  // Utils
  const helperText = getFileTypesMsg(accept) || helper;

  return (
    <label htmlFor={id} style={styles.label}>
      <Wrapper invalid={invalid}>
        <input
          id={id}
          type="file"
          onChange={onChange}
          multiple={multiple}
          hidden
          accept={getAcceptedFileTypes(accept)}
        />
        <Stack sx={styles.icon} alignItems="center" justifyContent="center">
          <CloudUploadOutlinedIcon />
        </Stack>
        <Box>
          <Typography sx={styles.heading}>{heading}</Typography>
          <Typography sx={styles.helper}>{helperText}</Typography>
        </Box>
      </Wrapper>
    </label>
  );
}
